var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Safras", {
        attrs: {
          nomeAba: _vm.nomeAba,
          anoSafra: _vm.forms.ano,
          areaDestinada: _vm.forms.areaDestinada,
          dataInicio: _vm.forms.dataInicio,
          praticasArray: _vm.pratica
        },
        on: {
          "update:anoSafra": function($event) {
            return _vm.$set(_vm.forms, "ano", $event)
          },
          "update:ano-safra": function($event) {
            return _vm.$set(_vm.forms, "ano", $event)
          },
          "update:areaDestinada": function($event) {
            return _vm.$set(_vm.forms, "areaDestinada", $event)
          },
          "update:area-destinada": function($event) {
            return _vm.$set(_vm.forms, "areaDestinada", $event)
          },
          "update:dataInicio": function($event) {
            return _vm.$set(_vm.forms, "dataInicio", $event)
          },
          "update:data-inicio": function($event) {
            return _vm.$set(_vm.forms, "dataInicio", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("PrevisaoColheita", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "validation-provider",
            [
              _c(
                "el-col",
                { attrs: { span: 23 } },
                [
                  _c("Label", {
                    attrs: { label: "Descrição", obrigatorio: false }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      name: "Descrição",
                      type: "textarea",
                      maxlength: "500",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.forms.descricao,
                      callback: function($$v) {
                        _vm.$set(_vm.forms, "descricao", $$v)
                      },
                      expression: "forms.descricao"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-end mt-3 mb-3" },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.validationDisableButton,
                round: "",
                type: "primary"
              },
              on: { click: _vm.btnAdicionar }
            },
            [
              _vm._v(
                "\n       " +
                  _vm._s(_vm.isEdit ? "Salvar" : "Adicionar") +
                  " Ano/Safra\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", { attrs: { gutter: 20 } }, [
        _c(
          "div",
          { staticClass: "flex-wrapper row" },
          _vm._l(_vm.pratica, function(item, index) {
            return _c("Card", {
              key: index,
              attrs: {
                objeto: {
                  ano: item.ano,
                  areaDestinada: item.areaDestinada + " ha",
                  dataInicio: _vm.formataStringYearMonthToBr(item.dataInicio)
                },
                titulo: "Ano safra: " + (item.ano || ""),
                deletar: function() {
                  return _vm.removerPratica(index)
                },
                editar: function() {
                  return _vm.editarPratica(item, index)
                }
              }
            })
          }),
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a75020d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a75020d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDG/SPDG.vue
// module id = null
// module chunks = 